import "es6-promise/auto";
import Vue from "vue";
import Axios from "axios";
import Common from "../../components/common.js";

Vue.component("common", Common);

new Vue({
  el: "#uz-taejung-notice",
  data: function() {
    return {
        viewModel: {
            list: [],
        }
    };
  },
  mounted: function() {
    let vm = this;
    try {
      vm.fnGetList();
    } catch (e) {
      console.log(e);
    }
  },
  methods: {
    fnGetList: function(){
      let vm = this;
      Axios.post("/taejung/board/list", {bbsId: "TJ_NOTICE"})
          .then(function(response) {
            let rs = response.data;
            vm.viewModel.list = rs.list;
            for (var i = 0; i < vm.viewModel.list.length; i++) {
              vm.viewModel.list[i].create_date = Common.fnConvertDateStr(vm.viewModel.list[i].create_date, "-");
            }
          })
          .catch(function(ex) {
            console.log(ex);
          });
    },
  }
});



// WEBPACK FOOTER //
// ./src/uz/taejung/taejung-notice-controller.js